import React from "react";
import { Link, useLocation } from "react-router-dom";
import NavLinks from "./components/nav/NavLinks";
import ThemeToggle from "./components/nav/ThemeToggle";

export default function NavBar() {
  const location = useLocation();
  const isReader = location.pathname.startsWith("/read");

  return (
    <header className="glass-bar sticky top-0 z-40" data-testid="site-nav">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 h-16 flex items-center justify-between gap-6">
        <Link
          to="/"
          className="flex items-center gap-3 group"
          data-testid="brand-link"
        >
          <span
            className="inline-flex h-8 w-8 items-center justify-center border-2 border-current font-display text-base font-bold"
            aria-hidden
          >
            N
          </span>
          <div className="leading-none">
            <div className="font-display tracking-widest text-[0.75rem] uppercase opacity-70">
              NewWaysToday
            </div>
            <div className="font-display font-bold uppercase text-[0.95rem] tracking-tight">
              The Hundredth Monkey
            </div>
          </div>
        </Link>

        <NavLinks isReader={isReader} />

        <div className="flex items-center gap-3">
          <ThemeToggle />
          <Link
            to="/read"
            className="hidden sm:inline-flex btn-ghost"
            data-testid="cta-read-nav"
          >
            Open Book
          </Link>
        </div>
      </div>
    </header>
  );
}
